import { useNavigate } from 'react-router-dom';

import { Typography } from 'antd';

import Header from '@/components/globals/Header';
import DocumentFile from '@/components/icons/DocumentFile';
import ShopBag from '@/components/icons/ShopBag';
import ActionCard from '@/components/shared/ActionCard';
import { MYEDUZZ_FRONT_URL } from '@/env';

const Home = () => {
  const navigate = useNavigate();

  return (
    <section className='bg-surface-default flex flex-1 flex-col'>
      <Header logoSize='large' />

      <div className='flex flex-1 flex-col justify-center px-14 md:justify-start md:pt-16'>
        <Typography.Title className='text-primary! mb-8! text-center lg:mb-16!' level={3}>
          O que deseja fazer hoje?
        </Typography.Title>

        <div className='flex flex-col gap-4 md:flex-row md:flex-wrap md:justify-center md:gap-8'>
          <ActionCard
            id='create-product-action'
            icon={ShopBag}
            title='Vender um produto'
            onClick={() => navigate('/product/create')}
          />
          <ActionCard
            id='access-purchased-product-action'
            icon={DocumentFile}
            title='Acessar um produto que comprei'
            onClick={() => window.open(`${MYEDUZZ_FRONT_URL}/producer/shopping`, '_self')}
          />
        </div>
      </div>
    </section>
  );
};

export default Home;
